/* eslint-disable react/jsx-curly-newline */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Common, Widget } from '@stockbit/ui';

import ListCloseIcon from '../Common/ListCloseIcon';
import ModalDelete from './ModalDelete';

import { ListContainer } from '../styled';

import { effects, selectors } from '../slice';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import SUCCESS_MESSAGE from 'constants/successMessage';

const { Text } = Common;
const { Button } = Widget;

interface ValuationListTypes {
  handleSwitchHamberger: () => void;
  dataTemplate: { id: string; name: string }[];
  onClick: (param: string) => void;
  setUpdateMode: (param: boolean) => void;
  setShowResultSection: (param: boolean) => void;
}

const ValuationList = ({
  handleSwitchHamberger,
  dataTemplate,
  onClick,
  setUpdateMode,
  setShowResultSection,
}: ValuationListTypes) => {
  const dispatch = useDispatch();
  const state = useSelector(selectors);
  const { postDeleteValuationTemplate, getValuationTemplateLoad } = state;
  const { isLoading: isLoadingDeleteValuation } = postDeleteValuationTemplate;

  const [hoveredRow, setHoveredRow] = useState('');
  const [valuationIdDelete, setValuationIdDelete] = useState(0);
  const [valuationNameDelete, setValuationNameDelete] = useState('');
  const [isValuationModalDelete, setValuationModalDelete] = useState(false);

  const handleOnClickDeleteValuation = (valuationId, valuationName) => {
    // set valuationIdDelete
    setValuationIdDelete(valuationId);
    // set valuationNameDelete
    setValuationNameDelete(valuationName);

    // show modal delete
    setValuationModalDelete(true);
  };

  const handleCancelValuationModalDelete = () => {
    // clear valuationNameDelete
    setValuationNameDelete('');

    // hide modal delete
    setValuationModalDelete(false);
  };

  const handleSubmitValuationModalDelete = async (valuationId) => {
    const del = await dispatch(
      effects.postDeleteValuationTemplate(valuationId),
    );

    // @ts-ignore
    const { error } = del.payload;

    if (!error) {
      handleErrorMessageAPI(
        `Template ${valuationNameDelete} has been deleted`,
        SUCCESS_MESSAGE.ALERT_GREEN,
      );
    }
  };

  useEffect(() => {
    const { isLoading } = getValuationTemplateLoad;

    // getValuationTemplateLoad success
    if (!isLoading) {
      // dispatch all valuation list
      dispatch(effects.getValuationTemplate());
    }
  }, [getValuationTemplateLoad, dispatch]);

  useEffect(() => {
    const { isSubmitted } = postDeleteValuationTemplate;

    // delete valuation success
    if (isSubmitted) {
      // hide modal delete
      setValuationModalDelete(false);

      // dispatch all valuation list
      dispatch(effects.getValuationTemplate());
    }
  }, [postDeleteValuationTemplate, dispatch]);

  const handleOnClickButton = () => {
    setUpdateMode(false);
    setShowResultSection(false);
    handleSwitchHamberger();
  };

  return (
    <div
      style={{
        height: 'calc(100% - 40px)',
        overflowY: 'auto',
        padding: '19px 12px 0',
      }}
    >
      <Button
        block
        round
        height="35px"
        margin="0 0 12px"
        type="defaultHoverable"
        onClick={handleOnClickButton}
      >
        <Text color="inherit" align="center">
          Create New Valuation
        </Text>
      </Button>
      {dataTemplate.map((template) => (
        <ListContainer
          key={template.id}
          onMouseEnter={() => setHoveredRow(template.id)}
          onMouseLeave={() => setHoveredRow('')}
        >
          <Text
            size="14px"
            height="30px"
            as="a"
            style={{ flex: 1 }}
            color="#6b6b6b"
            onClick={() => onClick(template.id)}
          >
            {template.name}
          </Text>
          <ListCloseIcon
            handleOnClickDelete={() =>
              handleOnClickDeleteValuation(template.id, template.name)
            }
          />
        </ListContainer>
      ))}

      {/* Modal delete */}
      <ModalDelete
        valuationId={valuationIdDelete}
        valuationName={valuationNameDelete}
        isVisible={isValuationModalDelete}
        onCancel={handleCancelValuationModalDelete}
        onSubmit={handleSubmitValuationModalDelete}
        isLoading={isLoadingDeleteValuation}
      />
    </div>
  );
};

export default ValuationList;
